/// <reference path="../../../scripts/typings/angular-ui/angular-ui-router.d.ts" />

//import personDataService = require("../core/persons.dataservice");
//import workplacesDataService = require("../core/workplaces.dataservice");

export function initialize(module: ng.IModule) {
    module.config(configure);

    configure.$inject = ["$stateProvider"];
}

function configure(
    $stateProvider: ng.ui.IStateProvider) {

    $stateProvider

        /*
         * Resources
         */
        .state("app.resources", {
            url: "/resources",
            abstract: true
        })

        /*
         * Persons
         */
        //.state("app.resources.persons", {
        //    url: "/persons",
        //    views: {
        //        "main-view@app": {
        //            template: require('./persons.html'),
        //            controller: "PersonsController",
        //            controllerAs: "vm"
        //        },
        //        "heading-view@app": {
        //            template: "Resources &raquo; Persons"
        //        }
        //    },
        //    resolve: {
        //        persons: ["personDataService", (personDataService: personDataService.IPersonDataService) => {
        //            return personDataService.getPersonsAndRelations();
        //        }]
        //    }
        //})

        /*
         * New Person
         */
        //.state("app.resources.persons.new", {
        //    url: "/new",
        //    views: {
        //        "main-view@app": {
        //            template: require('./persons.new.html'),
        //            controller: "PersonsNewController",
        //            controllerAs: "vm"
        //        }
        //    }
        //})

        /*
         * Edit Persons details
         */
        //.state("app.resources.persons.edit", {
        //    url: "/{personId:int}/edit",
        //    views: {
        //        "main-view@app": {
        //            template: require('./persons.edit.html'),
        //            controller: "PersonsEditController",
        //            controllerAs: "vm"
        //        }
        //    },
        //    resolve: {
        //        person: ["personDataService", "$stateParams", function (personDataService: personDataService.IPersonDataService, $stateParams) {
        //            return personDataService.get($stateParams.personId);
        //        }]
        //    }
        //})

        /*
         * Persons workplace
         */
        .state("app.resources.persons.workplaces", {
            url: "/{personId:int}/workplaces",
            abstract: true
        })

        /*
         * Edit Persons workplace
         */
        //.state("app.resources.persons.workplaces.edit", {
        //    url: "/edit",
        //    views: {
        //        "main-view@app": {
        //            template: require('./person.workplaces.edit.html'),
        //            controller: "PersonWorkplacesEditController",
        //            controllerAs: "vm"
        //        }
        //    },
        //    resolve: {
        //        person: ["personDataService", "$stateParams", function (personDataService: personDataService.IPersonDataService, $stateParams) {
        //            return personDataService.get($stateParams.personId);
        //        }],
        //        workplaces: ["workplaceDataService", function (workplaceDataService: workplacesDataService.IWorkplaceDataService) {
        //            return workplaceDataService.getAll();
        //        }]
        //    }
        //})

        /*
         * Persons job titles
         */
        .state("app.resources.persons.jobtitles", {
            url: "/{personId:int}/jobtitles",
            template: "<div ui-view class='reveal-animation'></div>",
            abstract: true
        })

        /*
         * Edit Persons job titles
         */
        //.state("app.resources.persons.jobtitles.edit", {
        //    url: "/edit",
        //    views: {
        //        "main-view@app": {
        //            template: "<h2>Edit job titles goes here</h2>",
        //        }
        //    }
        //})

        /*
         * Persons roles
         */
        .state("app.resources.persons.roles", {
            url: "/{personId:int}/roles",
            template: "<div ui-view class='reveal-animation'></div>",
            abstract: true
        })

        /*
         * Persons roles
         */
        .state("app.resources.persons.competences", {
            url: "/{personId:int}/competences",
            template: "<div ui-view class='reveal-animation'></div>",
            abstract: true
        })
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/resources.routes.ts